module.exports = __webpack_public_path__ + "media/widget/assets/images/Voca - logo-25f1030a1c6f21aff680f4d6d4c152c9.svg";